export const inchesToFeet = (inches: number) => inches / 12;

export const feetToInches = (feet: number) => feet * 12;
